export default __webpack_public_path__ + "static/media/system_process.f9bf59fd.png";